import React from "react";

export const Diagnosis03: React.FC = () => {
  return (
    <div className="diagnosis03-section">
      <div className="moreinfo-container">
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <p className="moreinfo-text">
              En cualquier caso es <span className="moreinfo-highlight-blue">MUY IMPORTANTE</span> que sepas que tener 
              exámenes de imagen normales no descarta la presencia de la enfermedad. Lamentablemente depende de la calidad del 
              aparato y de la formación del médico el resultado a interpretarse, y en algunos casos hay pacientes que tienen 
              lesiones pequeñas o más "ocultas" que no se ven en ningún estudio.
            </p>
            
            <p className="moreinfo-text diagnosis03-tip">
              <span className="moreinfo-highlight-blue">TIP:</span> te recomendamos que a medida que te vayas realizando 
              estudios, pidas la copia de las imágenes y de los informes para que tengas la evolución con el paso del tiempo. 
              Armar una carpeta con tus estudios previos siempre es útil y recomendable porque hará más ágil las consultas con 
              nuevos médicos.
            </p>
            
            <p className="moreinfo-text">
              En el caso de las resonancias, normalmente suelen darte un CD o un usuario online para acceder a las imágenes. 
              Tenerlas te va a permitir por ejemplo, hacer una consulta con otro especialista para pedir una segunda opinión.
            </p>
          </div>
          
          <div className="moreinfo-right">
            <div className="moreinfo-image-container">
              <img
                src="img/diagnosis3.png"
                className="moreinfo-image"
                alt="Diagnóstico por imagen"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};